module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_4"
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("I dedicate this book to Noah and Sophia, my first two children. May you grow up to be bold and loving witnesses for Christ. I hope you have the opportunity to see many people experience Jesus through your life and testimony.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d071e90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedication.vue
// module id = 63
// module chunks = 0